module.exports = __webpack_public_path__ + "static/media/list.30dd0605.svg";